import React from 'react';
import { GlowClickable, GlowIcon, Icons } from '@headless-workspace/glow-ds';
import { useSearchActionContext } from '../provider';

export const SearchButton = () => {
    'use memo';

    const { handleOpen } = useSearchActionContext();

    return (
        <GlowClickable
            onClick={handleOpen}
            content={{
                icon: <GlowIcon Icon={Icons.Search} type={'large'} />,
            }}
        />
    );
};
